export default __webpack_public_path__ + "1d3866d63e4624b21e9671fe9d39ece3.png";